module.exports = __webpack_public_path__ + "img/usgs-moon-map.49ee53b1.jpg";